export default "__VITE_ASSET__9QpwShy4__"